import { APIDecoratorWithBaseURI } from './api'

const PA_PREFIX = 'producer/analytics/'

/**
 * "Cupom" na UI == comissário com código no banco do painel.
 * Os endpoints derivam o ClienteId do evento no servidor — o front nunca envia.
 */

export interface Coupon {
  id: number
  nome: string
  codigo: string | null
  limite: number | null
  validade: string | null
  usados: number | null
}

export interface CouponsResponse {
  slug: string | null
  coupons: Coupon[]
}

export interface EventTicket {
  id: number
  nome: string
  setor: string | null
}

export interface CouponDiscount {
  id: number
  nome: string
  codigo: string
  porcentagem: number | null
  valor: number | null
}

export interface SaveCouponPayload {
  id: number
  codigo: string | null
  limite: number | null
  validade: string | null
}

export interface SaveDiscountPayload {
  comissarioId: number
  porcentagem: number | null
  valor: number | null
}

/** Erro de código duplicado — o backend devolve `CODIGO_JA_EM_USO:<codigo>`. */
export const parseDuplicatedCode = (error: any): string | null => {
  const message: string = error?.response?.data?.message ?? ''
  const match = message.match(/CODIGO_JA_EM_USO:([^\s]+)/)
  return match ? match[1] : null
}

export const getCoupons = async (eventId: string): Promise<CouponsResponse> => {
  const { data } = await APIDecoratorWithBaseURI().get(
    `${PA_PREFIX}coupons`,
    { params: { eventId } }
  )
  return data?.body ?? { slug: null, coupons: [] }
}

export const createCoupon = async (
  eventId: string,
  nome: string
): Promise<Coupon> => {
  const { data } = await APIDecoratorWithBaseURI().post(`${PA_PREFIX}coupons`, {
    eventId,
    nome,
  })
  return data?.body
}

export const saveCoupons = async (
  eventId: string,
  coupons: SaveCouponPayload[]
): Promise<void> => {
  await APIDecoratorWithBaseURI().post(`${PA_PREFIX}coupons/save`, {
    eventId,
    coupons,
  })
}

export const getEventTickets = async (
  eventId: string
): Promise<EventTicket[]> => {
  const { data } = await APIDecoratorWithBaseURI().get(
    `${PA_PREFIX}eventTickets`,
    { params: { eventId } }
  )
  return data?.body?.tickets ?? []
}

export const getCouponDiscounts = async (
  eventId: string,
  ingressoId: number
): Promise<CouponDiscount[]> => {
  const { data } = await APIDecoratorWithBaseURI().get(
    `${PA_PREFIX}couponDiscounts`,
    { params: { eventId, ingressoId } }
  )
  return data?.body?.coupons ?? []
}

export const saveCouponDiscounts = async (
  eventId: string,
  ingressoId: number,
  descontos: SaveDiscountPayload[]
): Promise<void> => {
  await APIDecoratorWithBaseURI().post(`${PA_PREFIX}couponDiscounts`, {
    eventId,
    ingressoId,
    descontos,
  })
}
